import React, {useEffect, useMemo} from "react";

import { LinksFilter } from '../../modules/LinksFilter';
import { LinksTable } from '../../modules/LinksTable';
import {useLinksUIContext} from "../../../contexts/LinksUIContext";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../redux/modules/links/actions";
import {fetchCategories} from "../../../../redux/modules/categories/actions";

export function LinksContainer() {
  const context = useLinksUIContext();
  const dispatch = useDispatch();

  const props = useMemo(() => ({
    queryParams: context.queryParams,
    onClick: (_, row) => context.openLinkDetailDialog(row.id),
  }), [context]);

  const {linkStore, categoryStore} = useSelector((state) => ({
    linkStore: state.links,
    categoryStore: state.categories,
  }), shallowEqual);

  const {totalCount, linkList, listLoading} = linkStore;
  const {categories} = categoryStore;

  useEffect(() => {
    dispatch(actions.fetchLinks(props.queryParams));
  }, [props.queryParams, dispatch]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  return (
    <div className="flex-grow-1">
      {/* Start:: LinksFilter */}
      <div className="mb-10">
        <LinksFilter categories={categories} />
      </div>
      {/* End:: LinksFilter */}

      {/* Start:: LinksTable */}
      <div className="mb-10">
        <LinksTable
          totalCount={totalCount}
          linkList={linkList}
          listLoading={listLoading}
        />
      </div>
      {/* End:: LinksTable */}
    </div>
  );
}
